<template>
  <a-modal class="date-modal-css" v-model="showModal" title="新建" width="1000px" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <a-form-model ref="baseForm" :model="formData">
      <a-row>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="加工组织"
            prop="organizationCode"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :rules="{'required':true,'message':' ','trigger':'change'}"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <global-select
              :allow-clear="false"
              :disabled="searchOrg!=='A001'"
              :value.sync="formData.organizationCode"
              selectType="select"
              :selectData="inventOrg"
              :selectItem="{ value: 'realValue', label: 'label' }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="物料编码"
            prop="itemCode"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :rules="{'required':true,'message':' ','trigger':'change'}"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <global-select
              v-model="formData.itemCode"
              selectType="selectSearch"
              requestApi="/mdm/mdmItemSystemItem/itemCodeBox"
              :selectItem="{ value: 'selectedValue', label: 'label' }"
              searchParam="itemCode"
              sourseField="res"
              :totalNum="9999999999"
              :dropdown-match-select-width="false"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="车工棉1200"
            prop="automotiveCottonOtzz"
            :rules="{'required':true,'message':' ','trigger':'change'}"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-select v-model="formData.automotiveCottonOtzz">
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0">否</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="车工棉2200"
            prop="automotiveCottonTtzz"
            :rules="{'required':true,'message':' ','trigger':'blur'}"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-select v-model="formData.automotiveCottonTtzz">
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0">否</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="车工复合棉"
            prop="automotiveCompositeCotton"
            :rules="{'required':true,'message':' ','trigger':'blur'}"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-select v-model="formData.automotiveCompositeCotton">
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0">否</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="扪工棉1200"
            prop="menggongCottonOtzz"
            :rules="{'required':true,'message':' ','trigger':'blur'}"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-select v-model="formData.menggongCottonOtzz">
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0">否</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="扪工棉2200"
            prop="menggongCottonTtzz"
            :rules="{'required':true,'message':' ','trigger':'blur'}"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-select v-model="formData.menggongCottonTtzz">
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0">否</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="扪工复合棉"
            prop="menggongCompositeCotton"
            :rules="{'required':true,'message':' ','trigger':'blur'}"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-select v-model="formData.menggongCompositeCotton">
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0">否</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="备注"
            prop="remark"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-input type="textarea" :autoSize="{minRows:2}" v-model="formData.remark" :maxLength="200" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <div class="footer-btn-wrapper">
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" :loading="loading" @click="onSubmit">确认</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import { apiOperationConfigCcAdd } from '@/api/mes/productionPrepare/silkProcessConfig'
export default {
  name: 'SilkAddRoleModal',
  data () {
    return {
      loading: false,
      showModal: false,
      searchOrg: '', // 查询组织
      formData: {
        organizationCode: undefined,
        itemCode: undefined,
        automotiveCottonOtzz: undefined,
        automotiveCottonTtzz: undefined,
        automotiveCompositeCotton: undefined,
        menggongCottonOtzz: undefined,
        menggongCottonTtzz: undefined,
        menggongCompositeCotton: undefined,
        remark: undefined // 备注
      }
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  methods: {
    // 展示
    show(organizationCode) {
      this.reset()
      this.searchOrg = organizationCode; // 查询组织
      this.formData.organizationCode = organizationCode
      this.showModal = true
    },
    // 取消
    onCancel() {
      this.showModal = false
    },
    // 重置
    reset() {
      this.formData = {
        organizationCode: undefined,
        itemCode: undefined,
        automotiveCottonOtzz: undefined,
        automotiveCottonTtzz: undefined,
        automotiveCompositeCotton: undefined,
        menggongCottonOtzz: undefined,
        menggongCottonTtzz: undefined,
        menggongCompositeCotton: undefined,
        remark: undefined // 备注
      }
    },
    // 提交
    onSubmit() {
      this.$refs.baseForm.validate(valid => {
        if(valid) {
          this.loading = true
          apiOperationConfigCcAdd(this.formData).then(res => {
            if (res?.code === 200) {
              this.$message.success('新增成功')
              this.$emit('refreshFun')
              this.showModal = false
            }
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.$message.warning('请检查必填项')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
